// A car's pages: its overview, settings, connections, service, library and recordings. On a desktop, a scope bar
// across the top of each; on a phone, rows on the overview, as iOS Settings lists a device's pages.
import type { ReactNode } from 'react';
import { ListLink, ListSection, ScopeBar } from '../../ui';
import { BooksIcon, GearIcon, PathIcon, PlugIcon, WrenchIcon } from '../../ui/icons';
import s from './Car.module.css';

interface Section {
  path: string;
  label: string;
  icon: ReactNode;
}

const SECTIONS: readonly Section[] = [
  { path: 'settings', label: 'Settings', icon: <GearIcon size={20} weight="bold" /> },
  { path: 'connections', label: 'Connections', icon: <PlugIcon size={20} weight="bold" /> },
  { path: 'service', label: 'Service', icon: <WrenchIcon size={20} weight="bold" /> },
  { path: 'library', label: 'Library', icon: <BooksIcon size={20} weight="bold" /> },
  { path: 'recordings', label: 'Recordings', icon: <PathIcon size={20} weight="bold" /> },
];

/** The scope bar, on a desktop only. */
export function CarScopes({ car }: { car: { id: string; nickname: string } }) {
  const base = `/garage/${car.id}`;
  return (
    <div className={s.scopes}>
      <ScopeBar
        label={`${car.nickname}'s pages`}
        scopes={[
          { to: base, label: 'Overview', end: true },
          ...SECTIONS.map((section) => ({ to: `${base}/${section.path}`, label: section.label })),
        ]}
      />
    </div>
  );
}

/** The rows, on a phone or a tablet only. */
export function CarRows({ car }: { car: { id: string; nickname: string } }) {
  return (
    <nav className={s.rows} aria-label={`${car.nickname}'s pages`}>
      <ListSection>
        {SECTIONS.map((section) => (
          <ListLink
            key={section.path}
            to={`/garage/${car.id}/${section.path}`}
            label={section.label}
            icon={section.icon}
          />
        ))}
      </ListSection>
    </nav>
  );
}
